// src/pages/UserTools/AI_UserTools/AiOverLay.jsx
import React, { useState } from 'react';
import { FaTriangleExclamation } from 'react-icons/fa6';
import './Ai_css/AiComponents.css';

// Centralised copy for the AI overlay so the importance of settings is explicit.
const AI_OVERLAY_COPY = {
  noteTitle: 'Your profile settings power the AI',
  noteBody:
    'Pure Health Nexus uses your age, sex, height, weight, daily activity and meal preferences to calculate your nutrition ranges and recommendations. ' +
    'Please complete these details carefully and keep them up to date so your guidance stays accurate and safe.',
};

export default function AiOverLay({ userName, onClose, onConsent }) {
  const [submitting, setSubmitting] = useState(false);

  const handlePersonalizeClick = async () => {
    if (typeof onConsent !== 'function') {
      return;
    }

    try {
      setSubmitting(true);
      await onConsent();
    } finally {
      setSubmitting(false);
    }
  };

  const handleOverlayClick = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  const handleBoxClick = (event) => {
    event.stopPropagation();
  };

  return (
    <div className="login-overlay" onClick={handleOverlayClick}>
      <div className="box" onClick={handleBoxClick}>
        <div className="ai-modal-content">
          <h3>Hi {userName}!</h3>

          {/* Caution note explaining why the upcoming settings really matter */}
          <p className="note note--caution" aria-live="polite">
            <FaTriangleExclamation className="note__icon" aria-hidden="true" />
            <span className="note__text">
              <strong>{AI_OVERLAY_COPY.noteTitle}.</strong>{' '}
              {AI_OVERLAY_COPY.noteBody}
            </span>
          </p>

          <h3 className="ai-headline">Pure Health Nexus AI-powered</h3>
          <p className="ai-subcopy">
            Designed to make your nutrition smarter and your body stronger. Let’s get started.
          </p>

          <button
            className="button"
            onClick={handlePersonalizeClick}
            disabled={submitting}
          >
            {submitting ? 'Starting…' : 'Personalize my intake'}
          </button>
        </div>
      </div>
    </div>
  );
}
